"use strict";

angular.module("vendor")
.service("CustomerSendNotificationService", function(
    $resource, FlashBag, gettextCatalog, common, PartnershipSelectorUnregisteredServiceFactory, appConfig
) {
    const LISTING_URL = "/auth/vendor/partnerships/list/";
    const URL_PARAMS = {valid_approved: 1};

    function CustomerSendNotificationService() {
        PartnershipSelectorUnregisteredServiceFactory.call(this, LISTING_URL, URL_PARAMS);
        var sendResource = $resource(appConfig.API_SERVER + "/auth/vendor/communication/notification-messages/send/", {}, {
            query: {
                method: "GET",
                isArray: true,
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            },
            save: {
                method: "POST",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });

        this.getBulkActionParams = function() {
            return {
                send_notification: {
                    text: gettextCatalog.getString("Send notification"),
                    message: gettextCatalog.getString("Do you really want to send a notification to these customers?"),
                    resource: sendResource,
                    successMessage: gettextCatalog.getString("Notifications was sent successfully."),
                    modalTemplatePrefix: "partnership-send-notification",
                    modalTemplatePackage: "vendor",
                    controller: "PartnershipSendNotificationConfirmationController",
                    controllerAs: "PartnershipSendNotificationConfirmationCtrl"
                }
            };
        };

        this.getSingleActionParams = function() {
            return this.getBulkActionParams();
        };

        this.getSortFields = function() {
            return common.getSortFieldsByKeys(
                "company_name, buyer_number, status_date",
                this.getAvailableSortFields()
            );
        };

    }

    return new CustomerSendNotificationService();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/customer-send-notification.service.js
// module id = 870
// module chunks = 0